import * as ChannelService from '@channel.io/channel-web-sdk-loader'
import { useContext, useEffect } from 'react'
import styled from 'styled-components'

import { abrViewWithdrawalAccount } from '../../utils/abr'

import { StoresContext } from '../../provider/StoreProvider'

import { useUserInfo } from '../../hooks/useUserInfo'

import { Wrap } from '../../components/container/Wrap'
import { Content } from '../../components/container/Content'
import { CenterWrap } from '../../components/common'
import { Button } from '../../components/button'
import { Text, StyledText } from '../../components/text'
import { Footer } from '../../components/footer'
import { Spinner } from '../../components/spinner/Spinner'
import { Header } from '../../components/header'

import { Color } from '../../theme/color'

import { ReactComponent as WarningIcon } from '../../assets/gui/warning.svg'

function Notice({ children }: { children: React.ReactNode }) {
  return (
    <NoticeItem>
      •
      <Text size={14} weight={500} lineHeight={20} block={true} color="text_secondary">
        {children}
      </Text>
    </NoticeItem>
  )
}

// *출금 계좌 등록 시작 페이지*
// 예치금 계좌 발급을 위한 출금 계좌 등록 시작 페이지
// 로그인, 본인인증을 해야지만 들어올 수 있으며, 출금 계좌/예치금 계좌 정보가 있으면 들어오지 못함
export function CreateWithdrawal() {
  const {
    commonStore: { setShowTab, setInvalidAccess },
  } = useContext(StoresContext)

  const { data: userInfo, isLogin, isCheckingLogin } = useUserInfo()

  const isAccount = !!userInfo?.withdrawalAccount && !!userInfo?.depositAccount

  useEffect(() => {
    if (!isLogin && !isCheckingLogin) setInvalidAccess(true)
  }, [isLogin, isCheckingLogin])

  useEffect(() => {
    if (isAccount) setInvalidAccess(true)
  }, [userInfo])

  useEffect(() => {
    abrViewWithdrawalAccount()
    ChannelService.track('view_withdrawal_account')
    setShowTab(false)
  }, [])

  if (isAccount) {
    return (
      <Wrap>
        <Header type="SUB" title="예치금 계좌 생성하기" />
        <CenterWrap>
          <Spinner />
        </CenterWrap>
      </Wrap>
    )
  }

  return (
    <Wrap>
      <Header type="SUB" title="예치금 계좌 생성하기" />
      <Content>
        <Container>
          <Text size={24} weight={600} lineHeight={34}>
            예치금 충전 계좌 발급을 위해
            <br />
            출금 계좌 등록이 필요해요.
          </Text>
          <WarningText size={14} weight={600}>
            <WarningIcon />
            하단 내용을 꼭 확인해주세요.
          </WarningText>
          <NoticeBox>
            <Notice>
              출금 계좌는 서비스 가입자{' '}
              <Text size={14} weight={700} color="text_secondary">
                본인 명의의 실계좌만 등록
              </Text>
              할 수 있어요.
            </Notice>
            <br />
            <Notice>
              <Text size={14} weight={700} color="text_secondary">
                평생 계좌 번호(휴대폰 번호, 사업자 번호 등)
              </Text>
              는 등록이 불가능해요.
            </Notice>
            <br />
            <Notice>
              계좌 개설일이 오래되어 계좌 번호가 바뀐 경우에는,{' '}
              <Text size={14} weight={700} color="text_secondary">
                새롭게 바뀐 계좌 번호로 등록
              </Text>
              하셔야 해요.
            </Notice>
            <br />
            <Notice>
              출금 계좌 등록 및 변경은, 하단 탭{' '}
              <Text size={14} weight={700} color="text_secondary">
                [더보기] &gt; [내 정보] &gt; [출금 계좌]
              </Text>
              에서 가능해요.
            </Notice>
          </NoticeBox>
        </Container>
      </Content>
      <Footer>
        <Button
          type="primary"
          size="large"
          block={true}
          href="/account/withdrawal/banks"
          routeProps={{ replace: true, state: { prevPathname: window.location.pathname } }}
        >
          시작하기
        </Button>
      </Footer>
    </Wrap>
  )
}

const Container = styled.div`
  padding: 24px;
  padding-top: 58px;
`

const WarningText = styled(StyledText)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 40px 0 16px;
`

const NoticeBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 8px;
  background-color: ${Color.primary_1};
`

const NoticeItem = styled.div`
  display: flex;
  gap: 4px;
`
